module.exports = __webpack_public_path__ + "files/20d0e9a9c5d0d1a9ac709c73897c95f4.png";